import { clsx } from 'clsx';
import { IWrapper } from './types';

export const Wrapper = ({ hatchPattern, hatchClasses, isValidated, children }: IWrapper) =>
  typeof isValidated === 'boolean' ? (
    <div className="flex h-full min-w-0 flex-1">
      <div className={clsx('w-2 shrink-0 mr-1', hatchPattern, hatchClasses)} />
      {children}
    </div>
  ) : (
    <>{children}</>
  );
